import { pxToRem } from "../../../utils/pxToRem";

export const featuresSectionHeading = {
  fontWeight: 600,
  fontSize: pxToRem(42),
  lineHeight: pxToRem(48),
};
